import api from './api';

export interface QuickReceiveInputLine {
  inventoryItemId: string;
  supplierId: string;
  receivedQty: number;
  unitCost?: number;
}

export interface QuickReceivePayload {
  venueId: string;
  /** The VenueLocation where received stock is placed. Required. */
  locationId: string;
  receivedDate: string;
  receivedBy: string;
  notes?: string;
  lines: QuickReceiveInputLine[];
}

export interface QuickReceiveGroupResult {
  supplierId: string;
  purchaseOrderId: string;
  goodsReceiptId: string;
  linesPosted: number;
  movementsCreated: number;
  poStatus: string;
}

export interface QuickReceiveGroupFailure {
  supplierId: string;
  error: string;
  code: string;
}

export interface QuickReceiveResult {
  results: QuickReceiveGroupResult[];
  failed: QuickReceiveGroupFailure[];
  totalMovementsCreated: number;
  summary: string;
}

const quickReceiveService = {
  submit: async (payload: QuickReceivePayload): Promise<QuickReceiveResult> => {
    const response = await api.post('/admin/quick-receive', payload);
    return response.data;
  },
};

export default quickReceiveService;
